import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getMyCheckoutRequests } from '../services/checkout-requestService';

const useMyCheckoutRequests = () => {
  const dispatch = useDispatch();
  const [checkoutRequests, setCheckoutRequests] = useState([]);
  const [checkoutRequestsLoading, setCheckoutRequestsLoading] = useState(false);

  const loadCheckoutRequests = useCallback(() => {
    executeApiAction({
      setLoading: setCheckoutRequestsLoading,
      dispatch,
      action: () => getMyCheckoutRequests(),
      onSuccess: (response) => setCheckoutRequests(response || []),
    });
  }, [dispatch]);

  useEffect(() => {
    loadCheckoutRequests();
  }, [loadCheckoutRequests]);

  return {
    checkoutRequests,
    checkoutRequestsLoading,
    refetchCheckoutRequests: loadCheckoutRequests,
  };
};

export default useMyCheckoutRequests;
